import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem } from "@mui/material";
import React from "react";
import { ISinisterValues } from "../../../shared/services/api/sinister/SinisterService";
import { useCanOpenModal } from "../hooks/useCanOpenModal";

type SinisterRowPropsType = {
	row: ISinisterValues;
	goTo: any;
};

export function RowMenu({ row, goTo }: SinisterRowPropsType) {
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);

	const handleClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleClose = () => {
		setAnchorEl(null);
	};

	const { canOpenModal } = useCanOpenModal();

	return (
		<>
			<Menu id={`actions-${row.id}`} anchorEl={anchorEl} open={open} onClose={handleClose}>
				{["aprovar", "rejeitar", "cancelar", "contestar"].map((action) => {
					const modalMap = {
						aprovar: "openModalAproved",
						rejeitar: "openModalRefused",
						cancelar: "openModalCancel",
						contestar: "openModalContested",
					} as const;

					const labelMap = {
						aprovar: "Aprovar",
						rejeitar: "Rejeitar",
						cancelar: "Cancelar",
						contestar: "Contestar",
					};

					const modalType = modalMap[action as keyof typeof modalMap];
					const { canOpen } = canOpenModal(modalType, row);

					return (
						<MenuItem
							key={action}
							disabled={!canOpen}
							onClick={(e) => {
								goTo(action, row.id, e, row);
								handleClose();
							}}
						>
							{labelMap[action as keyof typeof labelMap]}
						</MenuItem>
					);
				})}
			</Menu>

			<IconButton size="small" onClick={handleClick} aria-label="Ações">
				<MoreVertIcon fontSize="small" />
			</IconButton>
		</>
	);
}
